document.addEventListener("DOMContentLoaded", function() {
  var wishlistIcons = document.querySelectorAll(".wishlist-icon");

  wishlistIcons.forEach(function(icon) {
    icon.addEventListener("click", function(event) {
      event.preventDefault();

      var productId = icon.getAttribute("data-product-id");
      var wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
      console.log('wishlist>>>', wishlist);

      if (wishlist.includes(productId)) {
        wishlist = wishlist.filter(id => id !== productId);
        console.log("Product removed from wishlist: " + productId);
        icon.classList.remove("added-to-wishlist");
      } else {
        wishlist.push(productId);
        console.log("Product added to wishlist: " + productId);
        icon.classList.add("added-to-wishlist");
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));

      // Update wishlist count indicator
      updateWishlistIndicator();
    });
  });

  // Initialize icons based on existing wishlist items
  initializeWishlistIcons();

  if (document.getElementById('innerWishlistItem')) {
    displayWishlist();
  }

  function initializeWishlistIcons() {
    var wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    wishlistIcons.forEach(function(icon) {
      var productId = icon.getAttribute("data-product-id");
      if (wishlist.includes(productId)) {
        icon.classList.add("added-to-wishlist");
      }
    });
  }

  function updateWishlistIndicator() {
    var wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    if (wishlist.length > 0) {
      $('.js-number-wishlist.number-wishlist').addClass('active');
    } else {
      $('.js-number-wishlist.number-wishlist').removeClass('active');
    }
  }

  function displayWishlist() {
    var wishlistContainer = document.getElementById('innerWishlistItem');
    var wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    console.log('wishlist', wishlist);

    if (wishlist.length === 0) {
      $('.js-number-wishlist.number-wishlist').removeClass('active');
      var NolistItem = document.createElement("div");
      NolistItem.className = "empty-wishlist-item";
      NolistItem.innerHTML = "No Wishlist Products";
      wishlistContainer.innerHTML = '';  // Clear existing content
      wishlistContainer.appendChild(NolistItem);
      return; // Exit the function if there are no items in the wishlist
    }else{

     var Itemavlable = document.createElement("div");
      Itemavlable.className = "empty-wishlist-item";
      Itemavlable.innerHTML = "Love it? Add to your Wishlist";
      wishlistContainer.innerHTML = '';
       wishlistContainer.appendChild(Itemavlable);
    }

    wishlist.forEach(function(productId) {
      var wishlistitemurl = `https://lccollections.myshopify.com/products/${productId}.json`;
      var wishlistitemlink = `https://lccollections.myshopify.com/products/${productId}`;

      fetch(wishlistitemurl).then(function(response) {
        return response.json();
      }).then(function(productData) {
        if (productData && productData.product) {
          var listItem = document.createElement("li");
          listItem.innerHTML = `
            <div class="WishlistStyle" data-product-id="${productId}">
              <img src="${productData.product.image.src}" width="100" height="100">
              <a href="${wishlistitemlink}" class="test1"> ${productData.product.title}</a>
              <p class="test2"> $${productData.product.variants[0].price}</p>
              <button class="buttonstyle shop-button custom-add-toCart" vid="${productData.product.variants[0].id}">Add To Cart</button>
              <span class="remove-wishlist-item"><i class="ti-close"></i></span>
            </div>`;
          wishlistContainer.appendChild(listItem);

          // Add event listener for removing the item from the wishlist
          listItem.querySelector('.remove-wishlist-item').addEventListener('click', function() {
            var productIdToRemove = listItem.querySelector('.WishlistStyle').getAttribute('data-product-id');
            removeProductFromWishlist(productIdToRemove);
            wishlistContainer.removeChild(listItem);

            // Update wishlist indicator and message
            updateWishlistIndicator();
            if (wishlist.length === 0) {
              var NolistItem = document.createElement("div");
              NolistItem.className = "empty-wishlist-item";
              NolistItem.innerHTML = "No Wishlist Products";
              wishlistContainer.appendChild(NolistItem);
            }
          });
        }
      }).catch(function(error) {
        console.error("Error fetching product data:", error);
      });
    });
  }

  function removeProductFromWishlist(productId) {
    var wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    wishlist = wishlist.filter(id => id !== productId);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    
    // Also update the corresponding wishlist icon if present
    var icon = document.querySelector(`.wishlist-icon[data-product-id="${productId}"]`);
    if (icon) {
      icon.classList.remove("added-to-wishlist");
    }
    console.log("Product removed from wishlist: " + productId);

    // Reload the wishlist display
    displayWishlist();
  }

  // Initial call to update the wishlist indicator
  updateWishlistIndicator();
});



//Add wishlist product in cart
$(document).ready(function() {
  $('body').on('click', '.custom-add-toCart', function() {
    var variantId = $(this).attr('vid');
    var quantity = 1;

    fetch(`/cart/add.js?id=${variantId}&quantity=${quantity}`, {
      method: "POST"
    })
    .then(res => res.json())
    .then(res => {
      window.location.href = window.location.href;
    })
    .catch(error => {
      console.log('Error adding product to cart:', error);
    });
  });
});

